<template>
  <div class="bg-white">

    <notifications position="top center" ></notifications>

    <div class="flex flex-row">

      <div class="py-5 px-10">

        <div class="flex flex-col space-y-3 lg:space-y-5">

          <div class="mb-3  text-center">
            <h2 class="text-2xl block font-bold text-gray-700 text-sm">
              MAKE A PLEDGE
            </h2>
          </div>

          <div class="flex flex-row space-x-6">
            <div class="w-1/2">
              <label for="first_name" class="block font-bold text-gray-700 text-sm">
                First Name
              </label>
              <div class="mt-1">
                <!--              <input id="firstName" name="firstName" type="text" autocomplete="name" required class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">-->
                <input
                    class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    :class="{' border-red-500': errors.includes('first_name') === true, 'border-gray-160': errors.includes('first_name') === false }"
                    v-model="pledgeForm.first_name"
                    id="first_name"
                    name="first_name"
                    placeholder=""
                >
              </div>
            </div>
            <div class="w-1/2">
              <label for="last_name" class="block font-bold text-gray-700 text-sm">
                Last Name
              </label>
              <div class="mt-1">
                <input
                    class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    :class="{' border-red-500': errors.includes('last_name') === true, 'border-gray-160': errors.includes('last_name') === false }"
                    v-model="pledgeForm.last_name"
                    id="last_name"
                    name="last_name"
                    placeholder=""
                >
              </div>
            </div>
          </div>

          <div class="flex flex-row space-x-6">
            <div class="w-1/2">
              <label for="email" class="block font-bold text-gray-700 text-sm">
                Email
              </label>
              <div class="mt-1">
                <!--              <input id="firstName" name="firstName" type="text" autocomplete="name" required class="appearance-none block w-full px-3 py-2 border border-gray-300 shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">-->
                <input
                    class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    :class="{' border-red-500': errors.includes('email') === true, 'border-gray-160': errors.includes('email') === false }"
                    v-model="pledgeForm.email"
                    id="email"
                    name="email"
                    placeholder=""
                >
              </div>
            </div>
            <div class="w-1/2">
              <label for="phone" class="block font-bold text-gray-700 text-sm">
                Phone
              </label>
              <div class="mt-1">
                <input
                    class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    :class="{' border-red-500': errors.includes('phone') === true, 'border-gray-160': errors.includes('phone') === false }"
                    v-model="pledgeForm.phone"
                    id="phone"
                    name="phone"
                    placeholder=""
                >
              </div>
            </div>
          </div>


          <div>
            <label class="block font-bold text-gray-700 text-sm">
              How much would you like to donate?
            </label>
            <div class="switch-field grid gap-x-2 gap-y-2 grid-cols-3 mt-6 lg:mt-8">

              <div>
                <input type="radio" id="pledge_1" v-model="pledgeForm.selectedAmount" value="0.25" @click="toggleOtherAmountInView(false)">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_1">$0.25</label>
              </div>


              <div>
                <input type="radio" id="pledge_2" v-model="pledgeForm.selectedAmount" value="0.50" @click="toggleOtherAmountInView(false)">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_2">$0.50</label>
              </div>

              <div>
                <input type="radio" id="pledge_3" v-model="pledgeForm.selectedAmount" value="0.75" @click="toggleOtherAmountInView(false)">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_3">$0.75</label>
              </div>

              <div>
                <input type="radio" id="pledge_4" v-model="pledgeForm.selectedAmount" value="1" @click="toggleOtherAmountInView(false)">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_4">$1</label>
              </div>

              <div>
                <input type="radio" id="pledge_5" v-model="pledgeForm.selectedAmount" value="2" @click="toggleOtherAmountInView(false)">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_5">$2</label>
              </div>

              <div>
                <input type="radio" id="pledge_6" v-model="pledgeForm.selectedAmount" value="other"  @click="toggleOtherAmountInView(true); pledgeForm.selectedAmount = ''">
                <label class="cursor-pointer px-3 py-2 lg:px-6 lg:py-4 font-bold border border-gray-200 hover:bg-gray-50 text-center text-gray-400 w-full block" for="pledge_6">Other</label>
              </div>

            </div>


            <div  v-if="this.otherAmountInView"  class="mt-3 flex rounded-md shadow-sm">
                                <span class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                                    $
                                </span>
              <input
                  class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  :class="{' border-red-500': errors.includes('other-amount') === true, 'border-gray-160': errors.includes('other-amount') === false }"

                  name="other-amount"
                  id="alt_amount_input"
                  aria-label="Amount (to the nearest dollar)"
                  v-model="pledgeForm.enteredOtherAmount"
              >
            </div>

            <div class="flex flex-col space-y-3">

              <div class="flex mt-5">
                <input id="anonymous" type="checkbox" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 mt-1" @click="toggleExceedAmountInView()">
                <label for="anonymous" class="ml-2 block text-gray-900 text-left">
                  Not to exceed (total donation)

                </label>
              </div>

            </div>

            <div  v-if="this.exceedAmountInView"  class="mt-3 flex rounded-md shadow-sm">
                                <span class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                                    $
                                </span>
              <input
                  class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  :class="{' border-red-500': errors.includes('amount_limit') === true, 'border-gray-160': errors.includes('amount_limit') === false }"
                  name="amount_limit"
                  id="amount_limit"
                  v-model="pledgeForm.amount_limit"
              >
            </div>

          </div>


        </div>

        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button @click.prevent="makePledge" class="py-3 px-7 border border-transparent shadow-sm text-sm font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 uppercase">
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
    export default {
      name: 'MakePledgeWidgetNonModal',

      props: {
        campaignId: {
          type: String,
          required: true,
        },

        campaign: {
          required: false,
        },
      },

      created() {
        // this.$parent.$on('open-pledge-modal',  () => {
        this.emitter.on('open-pledge-modal',  () => {
          this.isOpen = true
        });
      },

      data() {
        return {
          isOpen: false,
          showThankYou: false,
          donationModalIsOpen: false,
          isSaving: false,
          otherAmountInView: false,
          exceedAmountInView: false,
          pledgeForm: {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            selectedAmount: '0.25',
            enteredOtherAmount: null,
            amount_limit: null,
            pledge_drive_id: (this.campaign && this.campaign.pledge_drive) ? this.campaign.pledge_drive.id : '',
            campaign_id: (this.campaign) ? this.campaign.id : '',
          },
          errors: []
        }
      },

      computed: {
        shouldShowCloseIcon() {
          return this.showCloseIcon
        },
      },

      methods: {
        toggleOtherAmountInView(value) {
          this.otherAmountInView = value
        },

        toggleExceedAmountInView() {
          this.exceedAmountInView = !this.exceedAmountInView
          if (!this.exceedAmountInView) {
            this.pledgeForm.amount_limit = null
          }
        },

        validEmail() {
          var re = /\S+@\S+\.\S+/;
          return re.test(this.pledgeForm.email);
        },

        validMoney(money) {
          if (money == '0.25' || money == '0.50' || money == '0.75' || money == '1' || money == '2') {
            return  true
          }
          // https://stackoverflow.com/questions/2227370/currency-validation
          var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/
          return regex.test(money);
        },
        makePledge() {
          this.isSaving = true

          this.errors = []

          // pledgeForm.enteredOtherAmount
          if (this.otherAmountInView) {
            if ( !this.pledgeForm.enteredOtherAmount) {
              this.errors.push('other-amount')
            }
            if (!this.validMoney(this.pledgeForm.enteredOtherAmount)) {
              this.errors.push('other-amount')
            }
            if ( !this.pledgeForm.amount_limit) {
              this.errors.push('other-amount')
            }
            if (!this.validMoney(this.pledgeForm.amount_limit)) {
              this.errors.push('other-amount')
            }

          } else {
            if (!this.validMoney(this.pledgeForm.selectedAmount)) {
              this.errors.push('other-amount')
            }
          }

          if (!this.pledgeForm.first_name) {
            this.errors.push('firstName')
          }
          if (!this.pledgeForm.last_name) {
            this.errors.push('last_name')
          }
          if (!this.pledgeForm.email || !this.validEmail()) {
            this.errors.push('email')
          }
          if (!this.pledgeForm.phone) {
            this.errors.push('phone')
          }

          if( this.errors.length > 0) {
            this.$notify({
              text: 'Please fix the validation errors',
              type: 'error',
            })
            this.isSaving = false
            return
          }

          axios.post('/api/open/campaigns/make-pledge/' + this.campaignId, this.pledgeForm).then((response) => {
            this.$notify({
              text: 'Pledge has been successfully made.',
              type: 'success',
            })
            this.showThankYou = true
            // console.log(response.data)
            // location.reload()
            this.emitter.emit('campaign-donation-update', response.data)

            setTimeout(() => {
              this.isOpen = false
              window.location.href = "/pledge-thank-you/"+this.campaignId;
            }, 2000)

          }).catch(reason => {
            // our interceptor fires off notification and we let user interact with form again
            //   this.isSaving = false
          })
        },
      },
    }
</script>

